import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

const VARIANTS = {
  desktop: {
    ids: { form: "header-search-form", input: "header-search-input", submit: "header-search-submit" },
    form: "flex-1 hidden md:flex",
    input: "flex-1 border-2 border-black px-4 py-2 text-base focus:outline-none focus:ring-2 focus:ring-[#0000EE] focus:border-[#0000EE] rounded-none font-mono-data placeholder:text-gray-500 placeholder:normal-case",
    button: "bg-black text-white px-4 py-2 border-2 border-black border-l-0 hover:bg-[#0000EE] hover:border-[#0000EE]",
    placeholder: "search listings — vehicles, electronics, jobs…",
    iconSize: 18,
  },
  mobile: {
    ids: { form: "mobile-search-form", input: "mobile-search-input", submit: "mobile-search-submit" },
    form: "md:hidden px-4 pb-3 flex",
    input: "flex-1 border-2 border-black px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-[#0000EE] rounded-none font-mono-data placeholder:normal-case",
    button: "bg-black text-white px-3 py-2 border-2 border-black border-l-0",
    placeholder: "search…",
    iconSize: 16,
  },
};

export function SearchForm({ variant, onDone }) {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const v = VARIANTS[variant];

  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    navigate(`/search?q=${encodeURIComponent(q.trim())}`);
    onDone?.();
  };

  return (
    <form onSubmit={submit} className={v.form} data-testid={v.ids.form}>
      <input data-testid={v.ids.input} type="text" value={q} onChange={(e) => setQ(e.target.value)} placeholder={v.placeholder} className={v.input} />
      <button data-testid={v.ids.submit} type="submit" className={v.button}><Search size={v.iconSize} strokeWidth={2.5} /></button>
    </form>
  );
}
